import React from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { Container } from './styles';
import { TooltipIcon } from 'assets/icons';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const StatusTooltip = ({
  createdAt,
  createdBy,
  type,
  reason,
  amount,
  transaction
}) => {

  return (
    <>
      <style>
        {`
          .rc-tooltip-placement-right > .rc-tooltip-arrow,
          .rc-tooltip-placement-left > .rc-tooltip-arrow {
            top: calc(50% - 1.5px) !important;
            left: 3px !important;
            border-width: 8px 12px 8px 0; !important;   
          }
          .rc-tooltip-placement-right > .rc-tooltip-arrow::before {
            border-width: 8px 12px 8px 0; !important; 
            top: -7.5px;
          }
        `}
      </style>
      <Tooltip
        placement="right"
        trigger={['hover']}
        overlay={
          <Container>
            <div className='item'>
              <span className='itemTitle'>
                {(createdAt? moment(createdAt).tz(TIME_ZONE).format('MMM Do YYYY h:mm A'): 'N/A') + ' by '}
                </span>
              <span className='createdBy'>{createdBy? createdBy: 'N/A'}</span>
            </div>
            <div className='item'>
              <span className='itemTitle'>{transaction? 'Description: ': `Reason for ${type}: ` }</span>
              <span className="tooltip-text">{reason || 'N/A'}</span>
            </div>
            <div className='item'>
              <span className='itemTitle'>{`${type} Amount:`}</span>
              <span className="tooltip-highlight"> {amount? ' $' + Number(amount).toFixed(2): 'N/A'}</span>
            </div>
          </Container>
        }
      >
        <TooltipIcon />
      </Tooltip>
    </>
  );
}

export default StatusTooltip;
